"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromiseAvailable = void 0;
exports.isPromiseAvailable = (function () {
    var globalNS = (function () {
        if (typeof global !== 'undefined') {
            return global;
        }
        if (typeof window !== 'undefined') {
            return window;
        }
        throw new Error('unable to locate global object');
    })();
    //tslint:disable-next-line
    return globalNS['Promise'] ? true : false;
})();
//# sourceMappingURL=promise.js.map